import React, { useState, useEffect, useCallback } from 'react';

import { Select } from 'antd';

import { toast } from 'react-toastify';

import { IoMdArrowBack } from 'react-icons/io';

import Swal from 'sweetalert2';

import { useSelector, useDispatch } from 'react-redux';

import history from '~/services/history';

import * as actions from '~/store/modules/generalIndicators/actions';

import Breadcumbs from '~/components/Breadcumbs';

import FileAnalysisCompleted from './FileAnalysisCompleted';

import { PageTitle, BoxAuth, BoxInstructions } from './style';

import BoxUpload from './components/Upload';

import templateCsv from '~/assets/template_indicadores_gerais_v1.csv';
import templateCsv2 from '~/assets/template_indicadores_gerais_v2.csv';

import { modalConfirmOptions } from './data/modalConfirmOptions';

const { Option } = Select;

const GeneralIndicators = () => {
  const [fileData, setFileData] = useState(null);

  const [originalName, setOriginalName] = useState(null);

  const [errorCompetence, setErrorCompetence] = useState(false);

  const [errorCnes, setErrorCnes] = useState(false);

  const [errorFile, setErrorFile] = useState(false);

  const [messageErrorFile, setMessageErrorFile] = useState(null);

  const [ondragoverError, setOndragoverError] = useState(false);

  const { roles, systemConfig } = useSelector(state => state.auth);
  const { errorData, generalIndicatorCompetences } = useSelector(
    state => state.generalIndicator
  );

  const [periodoSelecionado, setPeriodoSelecionado] = useState(null);

  const [anoSelecionado, setAnoSelecionado] = useState(null);

  const [competenciaAnterior, setCompetenciaAnterior] = useState(false);

  const { mesDeCompetencia, competenciaJaEnviada } = systemConfig;

  const [formDataFile, setFormDataFile] = useState(null);

  const dispath = useDispatch();

    
  useEffect(() =>{
    if(periodoSelecionado ){
    
    let anoPeriodo = periodoSelecionado.split("/")[1];
    setAnoSelecionado(anoPeriodo);

      setCompetenciaAnterior(
      anoPeriodo <= Number.parseInt('2023')
      ? true
      : false);
  }
    }, [periodoSelecionado])

  const ROLE_ADMIN = roles.includes('ROLE_ADMIN');

  if (ROLE_ADMIN) {
    history.push('/');
  }

  useEffect(() => {
    if (errorFile === true) {
      Swal.fire({
        title: 'Envio recusado!',
        text:
          !messageErrorFile ? 'Erro no arquivo. Tente novamente!' : messageErrorFile,
        icon: 'error',
        confirmButtonColor: '#74a50a',
      }).then(result => {
        if (result.value) {
          window.location.reload();
        }
      });
    }
  }, [errorFile, messageErrorFile]);

  useEffect(() => {
    if (ondragoverError) {
      toast.warn('Clique na área destacada para selecionar um arquivo .CSV.');
    }
  }, [ondragoverError]);

  useEffect(() => {
    dispath(actions.generalCompetencesRequest());

    try {
      const inputFileFied = document.getElementById('BoxUpload');
      inputFileFied.ondragover = () => {
        setOndragoverError(true);
      };
    } catch (error) {
      setOndragoverError(false);
    }
  }, [dispath]);

  const handleSubmit = useCallback(async () => {
    if (!fileData) {
      toast.error('Por favor selecione um arquivo.');

      Swal.fire({
        title: 'Atenção',
        text: 'Por favor selecione um arquivo.',
        icon: 'warning',
        confirmButtonColor: '#74a50a',
      });

      return;
    }

    const data = new FormData();
    data.append('arquivo', formDataFile);
    data.append('periodo', periodoSelecionado);

    dispath(
      actions.generalIndicatorsRequest({
        data,
      })
    );
  }, [dispath, fileData, formDataFile, periodoSelecionado]);

  const handleSubmitConfirm = useCallback(() => {
    if (mesDeCompetencia !== periodoSelecionado) {
      const comp = generalIndicatorCompetences?.filter(
        item => item.mesCompetencia === periodoSelecionado
      );

      if (comp.length > 0 && comp[0]?.enviado) {
        Swal.fire(modalConfirmOptions).then(result => {
          if (result.value) {
            handleSubmit();
          }
        });
      } else {
        handleSubmit();
      }

      return;
    }

    if (mesDeCompetencia === periodoSelecionado && competenciaJaEnviada) {
      Swal.fire(modalConfirmOptions).then(result => {
        if (result.value) {
          handleSubmit();
        }
      });
      return;
    }

    handleSubmit();
  }, [
    competenciaJaEnviada,
    handleSubmit,
    mesDeCompetencia,
    periodoSelecionado,
  ]);

  const handleSelectFile = useCallback(
    ({ file, data }) => {
      dispath(
        actions.generalIndicatorsFailure({
          errorData: null,
        })
      );

      setFileData(null);
      setOriginalName(null);
      setErrorCompetence(false);
      setErrorCnes(false);
      setErrorFile(false);
      setMessageErrorFile(null);
      setFormDataFile(file);
      setOriginalName(file.name);
      setFileData(data[0]);
    },
    [dispath]
  );

  useEffect(() => {
    if (errorData) {
      dispath(
        actions.generalIndicatorsFailure({
          errorData: null,
        })
      );
    }
  }, []);

  const handleBack = useCallback(() => {
    if (errorData) {
      dispath(
        actions.generalIndicatorsFailure({
          errorData: null,
        })
      );
    }
    setPeriodoSelecionado(null);
    setFileData(null);
  }, [dispath, errorData]);

  return (
    <>
      <Breadcumbs
        path="enviar-indicadores-gerais"
        pathTitle="Indicadores Gerais"
      />
      <PageTitle>
        {!periodoSelecionado ? (
          <div className="voltar">
            <button type="button" onClick={() => history.goBack()}>
              <IoMdArrowBack size={15} /> Voltar
            </button>
          </div>
        ) : (
          <div className="voltar">
            <button type="button" onClick={handleBack}>
              <IoMdArrowBack size={15} /> Voltar
            </button>
          </div>
        )}

        <div>
          <span>Upload do arquivo</span>
          {periodoSelecionado && (
            <p>
              {' '}
              | Mês de competência:{' '}
              <span className="currentMonth"> {periodoSelecionado}</span>
            </p>
          )}
        </div>
      </PageTitle>
      <BoxAuth>
        <>
          {fileData === null ? (
            <div className="BoxAuthContainer">
              <div className="title">
                <>
                  <h2>
                    Selecione o <span>mês de competência</span>
                    <br /> para envio de dados:
                  </h2>
                  <div className="selectMonth">
                    <Select
                      showSearch
                      style={{ width: 320 }}
                      placeholder="Escolha a competência"
                      onChange={value => setPeriodoSelecionado(value)}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {generalIndicatorCompetences.length > 0 &&
                        generalIndicatorCompetences.map(competencia => {
                          return (
                            <Option
                              key={competencia.mesCompetencia}
                              value={competencia.mesCompetencia}
                            >
                              {competencia.mesCompetencia}
                            </Option>
                          );
                        })}
                    </Select>
                  </div>
                </>
              </div>

              <BoxUpload
                    id="BoxUpload"
                    handleSelectFile={handleSelectFile}
                    originalName={originalName}
                    setErrorFile={setErrorFile}
                    setMessageErrorFile={setMessageErrorFile}
                  />

              {periodoSelecionado && competenciaAnterior ? (
                
                <>             
                
                  <BoxInstructions>
                    <span>Dúvidas sobre o padrão requerido?</span>
                    <p>
                      {periodoSelecionado != null ? (
                      <a
                        href={templateCsv}
                        target="_blank"
                        rel="noreferrer noopener"
                        title="Baixe aqui o template do arquivo CSV com instruções."
                        download="template_indicadores_gerais_v1.csv"
                      >
                        
                        Baixe aqui o template do arquivo
                        <br /> CSV com instruções.
                      </a>
                      ): (
                        <br />  
                        )
                        }
                    </p>
                  </BoxInstructions>
                </>
              ) : (
                <> 
                              
                  <BoxInstructions>
                    <span>Dúvidas sobre o padrão requerido?</span>
                    <p>
                    {periodoSelecionado != null ? (
                      <a
                        href={templateCsv2}
                        target="_blank"
                        rel="noreferrer noopener"
                        title="Baixe aqui o template do arquivo CSV com instruções."
                        download="template_indicadores_gerais_v2.csv"
                      >
                        Baixe aqui o template do arquivo
                        <br /> CSV com instruções.
                      </a>
                    ) : (
                        <br />
                    )}
                    </p>
                  </BoxInstructions>                </>

              )}
            </div>
          ) : (
            <FileAnalysisCompleted
              fileData={fileData}
              handleSelectFile={handleSelectFile}
              handleSubmit={handleSubmitConfirm}
              originalName={originalName}
              errorCompetence={errorCompetence}
              errorCnes={errorCnes}
              setErrorFile={setErrorFile}
              periodoSelecionado={periodoSelecionado}
              anoSelecionado={anoSelecionado}
            />
          )}
        </>
      </BoxAuth>
    </>
  );
};

export default GeneralIndicators;
